export default __webpack_public_path__ + "static/media/portfolio.bcb42124.png";